import { Box, Typography } from "@mui/material";
import type { FC } from "react";

export const SmsModalContent: FC = () => {
  return (
    <Box>
      <Typography sx={{ mt: 2 }} variant="body2">
        Make Communication Simple with SMS
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        For people in the field, always on the move, SMS keeps things personal, immediate, and
        actionable.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        With built-in analytics & language support, you’ll know your message landed and how it was
        received - and with advanced plans, you can even turn messages into two-way conversations.
      </Typography>
      <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
        Break through the noise of email and reach employees wherever they are, whether it’s your
        entire company or just one team.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Simple. Personal. Unmissable.
      </Typography>
    </Box>
  );
};
